import React, { FC } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useAppAuthenticationState } from '@dxb-web-ui-framework/iam/contexts/AppAuthentication';
import { useSelectedCustomerId } from '../../../../userProfile/src/contexts/UserInfo/hooks';
import { getRoutePath } from '../../../../content-composer/src/components/Routes/routePaths';

const EligibleRoute: FC = ({ children }) => {
  const customerId = useSelectedCustomerId();
  const { requiredApproved } = useAppAuthenticationState();
  const location = useLocation();

  if (!requiredApproved && !location.pathname.includes('termsCondition')) {
    return (
      <Navigate to={getRoutePath({ routeKey: 'terms-conditions', customerId })} replace state={{ from: location }} />
    );
  } else if (requiredApproved && location.pathname.includes('termsCondition')) {
    return <Navigate to={getRoutePath({ routeKey: 'dashboard', customerId })} replace state={{ from: location }} />;
  }

  return <>{children || null}</>;
};
export { EligibleRoute };
